import { render, staticRenderFns } from "./InfoSpotify.vue?vue&type=template&id=09f7aba2"
import script from "./InfoSpotify.vue?vue&type=script&lang=js"
export * from "./InfoSpotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports